import { render } from "./FeatureSection.vue?vue&type=template&id=081d9579&scoped=true"
import script from "./FeatureSection.vue?vue&type=script&lang=js"
export * from "./FeatureSection.vue?vue&type=script&lang=js"

import "./FeatureSection.vue?vue&type=style&index=0&id=081d9579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081d9579"]])

export default __exports__